var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-h3 mb-5"},[_vm._v(_vm._s(_vm.title))]),_c('MainFrame')],1)}
var staticRenderFns = []

export { render, staticRenderFns }